module.exports = "<p>\n  Bericht is succesvol verzonden!\n</p>\n"